import { useEffect } from 'react';
import { listPlaylistsWatchData } from './graphql/queries';

export default function usePlaylists({
  setWatchDataError,
  useLazyGraphQLQuery,
}) {
  const [listPlaylistsWatchDataQuery, listPlaylistsWatchDataResponse] =
    useLazyGraphQLQuery(listPlaylistsWatchData);

  useEffect(() => {
    const { error } = listPlaylistsWatchDataResponse;

    if (error) {
      setWatchDataError(true);
    }
  }, [listPlaylistsWatchDataResponse.error]);

  return {
    allPlaylistsStats:
      listPlaylistsWatchDataResponse.data?.listPlaylistsWatchData,
    loadingPlaylistsWatchData: listPlaylistsWatchDataResponse.loading,
    fetchPlaylistsWatchData: listPlaylistsWatchDataQuery,
  };
}
